import React, { useState, useEffect } from "react";
import { Modal, Button, Dropdown, Form, Spinner } from "react-bootstrap";

import {
  LogisticsClientsURL,
  LogisticsCompaniesURL,
} from "../../helpers/endpoints/api_endpoints";
import { axiosInstance } from "../../helpers/axios/axios";

const ExportModal = ({ show, handleClose, handleExport }) => {
  const [clients, setClients] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchClients();
    fetchCompanies();
  }, []);

  const fetchClients = async () => {
    try {
      const { data } = await axiosInstance.get(LogisticsClientsURL);
      setClients(data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  const fetchCompanies = async () => {
    try {
      const { data } = await axiosInstance.get(LogisticsCompaniesURL);
      setCompanies(data);
    } catch (err) {
      console.error("Error fetching companies:", err);
    }
  };

  const handleExportClick = async () => {
    setIsLoading(true);
    try {
      await handleExport({
        selectedClient,
        selectedCompany,
        startDate,
        endDate,
      });
      handleClose();
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetFilters = () => {
    setSelectedClient({ id: "", name: "Select Client" });
    setSelectedCompany({ id: "", name: "Select Company" });
    setStartDate("");
    setEndDate("");
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select Filters for Export</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Modal.Title> (optional)</Modal.Title>
        <Dropdown onSelect={(e) => setSelectedClient(e)} className="mb-2">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {clients?.results?.find(
              (client) => client.id === parseInt(selectedClient)
            )?.name || "Select Client"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {clients?.results?.map((client) => (
              <Dropdown.Item key={client.id} eventKey={client.id}>
                {client.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown onSelect={(e) => setSelectedCompany(e)} className="mb-2">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {companies?.results?.find(
              (company) => company.id === parseInt(selectedCompany)
            )?.name || "Select Company"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {companies?.results?.map((company) => (
              <Dropdown.Item key={company.id} eventKey={company.id}>
                {company.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <Form.Label className="mb-0 mt-2">Start Date</Form.Label>
        <Form.Control
          className="mb-2"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          placeholder="Start Date"
        />
        <Form.Label className="mb-0 mt-2">End Date</Form.Label>
        <Form.Control
          className="mb-2"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          placeholder="End Date"
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
          Close
        </Button>
        <Button
          variant="secondary"
          onClick={handleResetFilters}
          disabled={isLoading}
        >
          Reset Filters
        </Button>
        <Button
          variant="primary"
          onClick={handleExportClick}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Exporting…
            </>
          ) : (
            "Export"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportModal;
